import { useSelector } from "react-redux";

export default function SurveyForm() {
    const surveyLink = useSelector(state => state.survey.surveyLink);

    return (
        <iframe id="surveyIframe" src={surveyLink}></iframe>
    );
};
